// used by cph-epi\src\Cph.Website\Views\Blocks\BricksWrapperBlock\BricksWrapperBlock.cshtml

function initBrick() {
  var eventUpdate = new Event("masonry:update", { bubbles: true, cancelable: true })
  window.dispatchEvent(eventUpdate)

  document.querySelectorAll(".brick-category").forEach((element) => {
    element.addEventListener("click", () => {
      fetch("/api/BrickApi/ApplyFilters?contentLink=" + getBricksContentLink() + "&filters=" + getBricksFilters())
        .then((response) => response.json())
        .then((data) => domForBricks(data))
    })
  })

  document.querySelector("#show-more-bricks-button")?.addEventListener("click", () => {
    fetch("/api/BrickApi/showMore?contentLink=" + getBricksContentLink() + "&position=" + getPositionForBricks() + "&filters=" + getBricksFilters())
      .then((response) => response.json())
      .then((data) => domForBricks(data))
  })
}

function domForBricks(data) {
  document.querySelector("#bricksWrapper").outerHTML = data.View
  document.querySelector("#bricks-count").innerHTML = data.NumberOfBricks
  document.querySelector("#show-more-bricks").hidden = !data.ShowShowMoreBricksButton
  document.querySelector("#bricks-count").innerHTML = data.NumberOfBricks
  document.querySelector("#numberOfBricks").innerHTML = data.Position
  var eventInit = new Event("masonry:init", { bubbles: true, cancelable: true })
  var eventUpdate = new Event("masonry:update", { bubbles: true, cancelable: true })
  window.dispatchEvent(eventInit)
  window.dispatchEvent(eventUpdate)
}

function getBricksFilters() {
  var filters = ""
  document.querySelectorAll(".brick-category").forEach((element) => {
    if (element.classList.contains("is-active")) {
      filters += element.getAttribute("data-category") + ","
    }
  })
  return filters
}

function getBricksContentLink() {
  return document.querySelector("#currentBlock").textContent
}

function getPositionForBricks() {
  return document.querySelector("#numberOfBricks").textContent
}

if (document.readyState !== "loading") {
  initBrick()
} else {
  document.addEventListener("DOMContentLoaded", initBrick)
}
